<template>
  <form-wizard ref="add_service_estimates_form" color="#39C0ED" @on-complete="addConfirmation">
    <h2 slot="title"></h2>   
      <tab-content title="Service info" :before-change="()=>validateStep('childServiceInfoComponent')">
        <info-card @data="dataInfo" :service_estimate.sync="service_estimate" ref="childServiceInfoComponent"/>
      </tab-content>
      <tab-content v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 1" title="Client info" :before-change="()=>validateStep('childClientComponent')">
        <client-card @data="dataClient" :service_estimate="service_estimate" ref="childClientComponent"/>
      </tab-content>
      <tab-content v-if="service_estimate.service_estimate_type == 1 && service_estimate.service_estimate_billed == 2" title="Client/Driver info" :before-change="()=>validateStep('childDriverComponent')">
        <driver-card @data="dataClient" :service_estimate="service_estimate" ref="childDriverComponent"/>
      </tab-content>
      <tab-content :title="service_estimate.service_estimate_type != 2?'Vehicle Info':'Vehicle & Custumer Info'" :before-change="()=>validateStep('childVehicleComponent')">
        <vehicle-card @data="dataVehicle"  :service_estimate="service_estimate" ref="childVehicleComponent"/>
      </tab-content>
      <tab-content title="Service step" :before-change="()=>validateStep('childServiceComponent')">
        <service-card @data="dataService" :service_estimate="service_estimate" ref="childServiceComponent"/>
      </tab-content>
      <tab-content title="Part step" :before-change="()=>validateStep('childPartComponent')">
        <part-card @data="dataPart" :service_estimate="service_estimate" ref="childPartComponent"/>
      </tab-content>
 
  </form-wizard>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

// import komponen
import InfoCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/InfoCard.vue";
import ClientCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ClientCard.vue";
import DriverCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/DriverCard.vue";
import VehicleCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/VehicleCard.vue";
import ServiceCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ServiceCard.vue";
import PartCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/PartCard.vue";
import Swal from 'sweetalert2';
import Vue from "vue";
export default {
  name: "add-service-categories",

    // props: {
    //   service_estimate: Object,
    // },

  components: {
    // ValidationError,
    FormWizard,
    TabContent,
    "info-card": InfoCard,
    "client-card": ClientCard,
    "vehicle-card": VehicleCard,
    "service-card": ServiceCard,
    "part-card": PartCard,
    "driver-card" : DriverCard,
      
  },

  props: {
    data_id: null,
    },

  mixins: [formMixin],

  data: () => ({
    service_estimate: [],
  }),

  created() {
    this.getServiceEstimateData();
  },

  methods: {
    //fungsi dipanggile saat page pertamakali dibuka
    async getServiceEstimateData(){
      //check id ikut terkirim di route
      if(this.data_id.id){

        //ambil data di server sesuai dengan data id yang ada di route
        await this.$store.dispatch("workshop_service_estimate/get", this.data_id.id)
        this.service_estimate = await this.$store.getters["workshop_service_estimate/service_estimate"]

          // await this.$store.dispatch("workshop_service_estimate/list_service", this.$route.params.id)
          // this.service_estimate.service = await this.$store.getters["workshop_service_estimate/service_estimate"]

          // await this.$store.dispatch("workshop_service_estimate/list_part", this.$route.params.id)
          // this.service_estimate.part = await this.$store.getters["workshop_service_estimate/service_estimate"]

          // await this.$store.dispatch("workshop_client_master/get", "3")
          // this.service_estimate.client = await this.$store.getters["workshop_client_master/client_master"]
          // this.service_estimate.vehicle_type = this.service_estimate.service_estimate_vehicle_id
          // console.log( this.service_estimate.service)
          // console.log( this.service_estimate.part)

        //set value bersarkan data yang yang diterima dari server
        // this.service_estimate.vehicle_type = this.service_estimate.service_estimate_vehicle.id
        // this.service_estimate.vehicle_brand = this.service_estimate.service_estimate_vehicle.vehicle_brand_id
        // this.service_estimate.vehicle_brand_text = this.service_estimate.service_estimate_vehicle.vehicle_brand_name
        // this.service_estimate.vehicle_type_text = this.service_estimate.service_estimate_vehicle.vehicle_type+' - '+ this.service_estimate.service_estimate_vehicle.vehicle_year_model
        // this.service_estimate.service_estimate_vehicle_text = this.service_estimate.vehicle_brand_text+' '+this.service_estimate.vehicle_type_text
        this.service_estimate.service_estimate_service_advisor = this.service_estimate.service_estimate_service_advisor_name.id
        this.service_estimate.service_estimate_pool = this.service_estimate.service_estimate_pool.id


         //butuh jeda time sebelum mengupdate value di chield client
        var self = this;
        setTimeout(function(){
          self.$refs.childServiceInfoComponent.getDataParent()
          // console.log(this.service_estimate)
          if(self.$refs.childClientComponent){
            self.$refs.childClientComponent.getDataParent()
          }
          if(self.$refs.childDriverComponent){
            self.$refs.childDriverComponent.getDataParent()
          }
          // console.log(this.service_estimate);
          // if(this.service_estimate.service_estimate_type == 1 && this.service_estimate.service_estimate_billed == 1){
          //   this.$refs.childClientComponent.getData()
          //   }
          //   if(this.service_estimate.service_estimate_type == 1 && this.service_estimate.service_estimate_billed == 2){
          //   this.$refs.childDriverComponent.getData()
          //   }

          self.$refs.childVehicleComponent.getDataParent()
          self.$refs.childServiceComponent.getDataParent()
          self.$refs.childPartComponent.getDataParent()
        }, 1);
           
           
          

      }
      else{
        //jika tidak ada kembali ke list
        await this.$router.replace({name: 'List Service Estimate'});
      }
    },

    async addConfirmation() {
     
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.editServiceEstimate()
        }
      });
    },

    // fungsi edit data
    async editServiceEstimate() {
      //ambil data dari child page
      this.$refs.childServiceInfoComponent.getData()
      if(this.service_estimate.service_estimate_type == 1 && this.service_estimate.service_estimate_billed == 1){
       this.$refs.childClientComponent.getData()
      }
      if(this.service_estimate.service_estimate_type == 1 && this.service_estimate.service_estimate_billed == 2){
       this.$refs.childDriverComponent.getData()
      }
      this.$refs.childVehicleComponent.getData()
      this.$refs.childServiceComponent.getData()
      this.$refs.childPartComponent.getData()
      //console.log(this.service_estimate)

      //set var data yang akan dikirm ke server
      const data = {
        type: "workshop_service_estimates",
        id:this.service_estimate.id,
        service_estimate_create_at_datetime: this.service_estimate.service_estimate_create_at_datetime,
        service_estimate_guarantee: this.service_estimate.service_estimate_guarantee,
        service_estimate_ppn: this.service_estimate.service_estimate_ppn,
        service_estimate_service_advisor: this.service_estimate.service_estimate_service_advisor,
        service_estimate_type: this.service_estimate.service_estimate_type,
        service_estimate_billed: this.service_estimate.service_estimate_billed?this.service_estimate.service_estimate_billed:null,
        service_estimate_pool: this.service_estimate.service_estimate_pool,
        service: this.service_estimate.service,
        part : this.service_estimate.part,
        service_estimate_client_id: this.service_estimate.client?this.service_estimate.client.id:null,
        service_estimate_client_driver_business_type: this.service_estimate.client && this.service_estimate.client.driver_business_type?this.service_estimate.client.driver_business_type:null,
        service_estimate_vehicle_id: this.service_estimate.vehicle.id,
        service_estimate_vehicle_km: this.service_estimate.vehicle.vehicle_km,
        keluhan: this.service_estimate.keluhan
      }
      // console.log(this.service_estimate.info)
       console.log(data)
      try {
          //kirim data ke server
        await this.$store.dispatch("workshop_service_estimate/update", data);
             //panggil alert succes
        await this.$store.dispatch(
        "alerts/success",
        "Successfully registered."
        );
        //kembali ke list
        // await this.$router.push({name: 'List Service Estimate'});
      this.$parent.$parent.modalCloseEdit();

      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
        "alerts/error",
        "Oops, something went wrong"
        );
        this.setApiValidation(e.response.data.errors);
      }

    },
      
      //set data yang diambil dari child info
    dataInfo (value) {
      console.log(value) 
      this.service_estimate.info = value
      
    },
    
    //set data yang diambil dari child client
    dataClient (value) {
      console.log(value) 
      this.service_estimate.client = value
    },
      
      //set data yang diambil dari child vehicle
    dataVehicle (value) {
      //console.log(value) 
      this.service_estimate.vehicle = value
    },
    
    //set data yang diambil dari child service
    dataService (value) {
      console.log(value) 
      console.log("bahahaha")
      this.service_estimate.service = value
    },
    
    //set data yang diambil dari child part
    dataPart (value) {
      // console.log(value) 
      this.service_estimate.part = value
    },
    
    //checke validasi stiap child sebulum pindah section
    validateStep(name) {
      var refToValidate = this.$refs[name]
      return refToValidate.validateForm()
    },
  }
};
</script>
 